import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import Layout from './components/Layout';
import DashboardPage from './pages/DashboardPage';
import FamilyCardPage from './pages/FamilyCardPage';
import QRCheckPage from './pages/QRCheckPage';
import BCMembersPage from './pages/BCMembersPage';
import MembersPage from './pages/MembersPage';
import MemberDetailPage from './pages/MemberDetailPage';
import CouponsPage from './pages/CouponsPage';
import ReferralsPage from './pages/ReferralsPage';
import SettingsPage from './pages/SettingsPage';
import LoyaltyPage from './pages/LoyaltyPage';
import PagesPage from './pages/PagesPage';
import PromotionsPage from './pages/PromotionsPage';
import CRMPage from './pages/CRMPage';
import PromoCodesPage from './pages/PromoCodesPage';
import NotificationsPage from './pages/NotificationsPage';
import CampaignsPage from './pages/CampaignsPage';
import StaffVerifyPage from './pages/StaffVerifyPage';
import ActivityPage from './pages/ActivityPage';
import AbandonedPage from './pages/AbandonedPage';
import RefundsPage from './pages/RefundsPage';
import CounterPage from './pages/CounterPage';
import StoreStaffPage from './pages/StoreStaffPage';
import ScanAlertsPage from './pages/ScanAlertsPage';
import UsersPage from './pages/UsersPage';
import ReportsPage from './pages/ReportsPage';
import SyncHealthPage from './pages/SyncHealthPage';

function PrivateRoute({ children }) {
  const token = localStorage.getItem('admin_token');
  return token ? children : <Navigate to="/login" replace />;
}

// Where "/" goes depends on who is signed in: a store account cannot open the
// dashboard, and bouncing them to a page that refuses them is a poor first
// impression of a tool they use fifty times a day.
function RoleHome() {
  let role = null;
  try { role = JSON.parse(localStorage.getItem('admin_info') || '{}').role; } catch {}
  return <Navigate to={role === 'store' ? '/counter' : '/dashboard'} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/verify" element={<StaffVerifyPage />} />
        {/* Public: a family member opening the link their parent showed them.
            Apache serves this SPA for every non-/api path, so the backend page
            at the same URL never reaches them. */}
        <Route path="/family/:token" element={<FamilyCardPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<RoleHome />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="activity" element={<ActivityPage />} />
          <Route path="abandoned" element={<AbandonedPage />} />
          <Route path="refunds" element={<RefundsPage />} />
          <Route path="counter" element={<CounterPage />} />
          <Route path="counter-staff" element={<StoreStaffPage />} />
          <Route path="scan-alerts" element={<ScanAlertsPage />} />
          <Route path="users" element={<UsersPage />} />
          {/* The page was called Till first. Anyone who bookmarked it keeps
              working rather than landing on a blank route. */}
          <Route path="till" element={<Navigate to="/counter" replace />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="sync-health" element={<SyncHealthPage />} />
          <Route path="members" element={<MembersPage />} />
          <Route path="members/:id" element={<MemberDetailPage />} />
          <Route path="bc-members" element={<BCMembersPage />} />
          <Route path="qr-check" element={<QRCheckPage />} />
          <Route path="coupons" element={<CouponsPage />} />
          <Route path="referrals" element={<ReferralsPage />} />
          <Route path="loyalty"   element={<LoyaltyPage />} />
          <Route path="crm"        element={<CRMPage />} />
          <Route path="promo-codes"    element={<PromoCodesPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="campaigns" element={<CampaignsPage />} />
          <Route path="promotions" element={<PromotionsPage />} />
          <Route path="pages"    element={<PagesPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
